import { ActionPermission } from '@luminovo/api-contracts';
import { assertUnreachable } from '@luminovo/commons';

export type ActionPermissionTest =
    | ActionPermission
    | {
          permissions: ActionPermission[];
          type: 'any' | 'all';
      }
    | ((permissions: ActionPermission[]) => boolean);

export function isAuthorizedForAction(actionPermissions: ActionPermission[], test: ActionPermissionTest): boolean {
    if (typeof test === 'string') {
        return actionPermissions.includes(test);
    }
    if (typeof test === 'function') {
        return test(actionPermissions);
    }
    if (test.type === 'any') {
        return test.permissions.some((p) => actionPermissions.includes(p));
    } else if (test.type === 'all') {
        return test.permissions.every((p) => actionPermissions.includes(p));
    }
    assertUnreachable(test.type);
}
